export default "__VITE_ASSET__448eb662__"